/* tslint:disable */
/* eslint-disable */
/**
 * Coworker IAM API
 * Provides coworker identity and access management functionalities
 *
 * The version of the OpenAPI document: 1.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreferencesDto
 */
export interface PreferencesDto {
    /**
     * Business unit code
     * @type {string}
     * @memberof PreferencesDto
     */
    buCode?: string;
    /**
     * Language code in format xx-YY
     * @type {string}
     * @memberof PreferencesDto
     */
    language?: string;
    /**
     * Store name
     * @type {string}
     * @memberof PreferencesDto
     */
    storeName?: string;
    /**
     * List of HFB (Home Furnishing Business) codes
     * @type {Array<string>}
     * @memberof PreferencesDto
     */
    hfbList?: Array<string>;
    /**
     * Order creation method
     * @type {string}
     * @memberof PreferencesDto
     */
    orderCreationMethod?: string;
    /**
     * Coworker meeting point
     * @type {string}
     * @memberof PreferencesDto
     */
    coworkerMeetingPoint?: string;
    /**
     * Coworker work area
     * @type {string}
     * @memberof PreferencesDto
     */
    coworkerWorkArea?: string;
}

/**
 * Check if a given object implements the PreferencesDto interface.
 */
export function instanceOfPreferencesDto(value: object): boolean {
    return true;
}

export function PreferencesDtoFromJSON(json: any): PreferencesDto {
    return PreferencesDtoFromJSONTyped(json, false);
}

export function PreferencesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreferencesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'buCode': json['buCode'] == null ? undefined : json['buCode'],
        'language': json['language'] == null ? undefined : json['language'],
        'storeName': json['storeName'] == null ? undefined : json['storeName'],
        'hfbList': json['hfbList'] == null ? undefined : json['hfbList'],
        'orderCreationMethod': json['orderCreationMethod'] == null ? undefined : json['orderCreationMethod'],
        'coworkerMeetingPoint': json['coworkerMeetingPoint'] == null ? undefined : json['coworkerMeetingPoint'],
        'coworkerWorkArea': json['coworkerWorkArea'] == null ? undefined : json['coworkerWorkArea'],
    };
}

export function PreferencesDtoToJSON(value?: PreferencesDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'buCode': value['buCode'],
        'language': value['language'],
        'storeName': value['storeName'],
        'hfbList': value['hfbList'],
        'orderCreationMethod': value['orderCreationMethod'],
        'coworkerMeetingPoint': value['coworkerMeetingPoint'],
        'coworkerWorkArea': value['coworkerWorkArea'],
    };
}

